(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Dropdown menu functionality
  document.addEventListener('DOMContentLoaded', function() {
    const dropdowns = document.querySelectorAll('.header__account-menu .dropdown');
    const profileDropdowns = document.querySelectorAll('.profile-avatar-dropdown');

  // Helper to keep body state in sync with any open profile dropdown
  function syncProfileBodyState() {
    const anyActive = Array.from(profileDropdowns).some(dropdown => dropdown.classList.contains('active'));
    document.body.classList.toggle('profile-menu-open', anyActive);
  }

  // Function to close all dropdowns
  function closeAllDropdowns() {
    dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
    profileDropdowns.forEach(dropdown => dropdown.classList.remove('active'));
    syncProfileBodyState();
  }

    // Handle dropdown toggles
    dropdowns.forEach(dropdown => {
      const toggle = dropdown.querySelector('.dropdown-toggle');
      if (toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          // Close other dropdowns
          dropdowns.forEach(otherDropdown => {
            if (otherDropdown !== dropdown) {
              otherDropdown.classList.remove('active');
            }
          });

          // Toggle this dropdown
          dropdown.classList.toggle('active');
        });
      }
    });

  // Handle profile avatar dropdowns (desktop + mobile)
  profileDropdowns.forEach(profileDropdown => {
    const profileAvatar = profileDropdown.querySelector('.profile-avatar');
    if (profileAvatar) {
      profileAvatar.addEventListener('click', function(e) {
        e.stopPropagation();
        const wasActive = profileDropdown.classList.contains('active');

        // Close other dropdowns
        closeAllDropdowns();

        // Re-open this dropdown if it was previously closed
        if (!wasActive) {
          profileDropdown.classList.add('active');
        }

        syncProfileBodyState();
      });
    }

    const profileMenu = profileDropdown.querySelector('.dropdown-menu');
    if (profileMenu) {
      profileMenu.addEventListener('mouseenter', function() {
        profileDropdown.classList.add('active');
        syncProfileBodyState();
      });
      profileMenu.addEventListener('mouseleave', function() {
        if (!profileDropdown.matches(':hover')) {
          profileDropdown.classList.remove('active');
          syncProfileBodyState();
        }
      });
    }
  });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.dropdown') && !e.target.closest('.profile-avatar-dropdown')) {
        closeAllDropdowns();
      }
    });

    // Keep dropdown open when hovering over dropdown menu
    dropdowns.forEach(dropdown => {
      const menu = dropdown.querySelector('.dropdown-menu');
      if (menu) {
        menu.addEventListener('mouseenter', function() {
          dropdown.classList.add('active');
        });
        menu.addEventListener('mouseleave', function(e) {
          // Only close if not hovering over the parent dropdown
          if (!dropdown.matches(':hover')) {
            dropdown.classList.remove('active');
          }
        });
      }
    });

    // Ensure body state reflects the current dropdown state on load
    syncProfileBodyState();
  });

  // Collections drawer functionality
  document.addEventListener('DOMContentLoaded', function() {
    const drawer = document.getElementById('collections-drawer');
    const overlay = document.getElementById('collections-drawer-overlay');
    const toggleButton = document.querySelector('.collections-drawer-toggle');
    const closeButton = document.querySelector('.collections-drawer-close');

    console.log('Collections drawer elements:', { drawer, overlay, toggleButton, closeButton });

    if (!drawer || !overlay || !toggleButton) {
      console.warn('Collections drawer elements not found');
      return;
    }

    function openDrawer() {
      drawer.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      toggleButton.setAttribute('aria-expanded', 'true');

      // Focus management for accessibility
      const firstFocusableElement = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      toggleButton.setAttribute('aria-expanded', 'false');
      toggleButton.focus();
    }

    // Toggle button click
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Toggle button clicked, drawer open:', drawer.classList.contains('open'));
      if (drawer.classList.contains('open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    // Close button click
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer();
      });
    }

    // Overlay click
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeDrawer();
      }
    });

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) {
        closeDrawer();
      }
    });

    // Trap focus within drawer when open
    drawer.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        const focusableElements = drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
